import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["editionSelect"]

  connect() {
    console.log("Course selector controller connected")
  }

  select(event) {
    event.preventDefault()
    const courseTitle = event.currentTarget.dataset.courseTitle

    if (courseTitle && this.hasEditionSelectTarget) {
      this.editionSelectTarget.value = courseTitle
    }

    document.querySelector('#info-box').scrollIntoView({
      behavior: 'smooth'
    })
  }
}